import { Http } from './Http'

export async function checkAllowedToAccessPermission (rallyRoundId: string|number) {
  const res = await Http.request(`/api/auth/check-rally-round-permission/${rallyRoundId}`)
  if (!res.ok) {
    window.location.href = '/teamarea'
  }
}
